export default __webpack_public_path__ + "static/media/icon_transfer_inactive_new.bfd8b5ef.svg";